import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function OAuthSuccess() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { fetchUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleSSOLogin = async () => {
      if (!token) {
        navigate("/login?error=missing_token");
        return;
      }

      // Stocker le token
      localStorage.setItem("token", token);

      // Charger les infos utilisateur
      const user = await fetchUser();
      console.log(user)
        navigate("/");
    };

    handleSSOLogin();
  }, [token, fetchUser, navigate]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <Typography>Connexion via Microsoft...</Typography>
      <CircularProgress />
    </Box>
    );
}
